import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Eye } from 'lucide-react'
import DeviceDetailDialog from './DeviceDetailDialog'
import { DeviceData } from '../columns'

interface ActionCellProps {
  device: DeviceData
}

export default function ActionCell({ device }: ActionCellProps) {
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <>
      <Button variant="ghost" size="sm" onClick={() => setDialogOpen(true)}>
        <Eye className="h-4 w-4 mr-1" />
        查看
      </Button>

      <DeviceDetailDialog device={device} open={dialogOpen} onOpenChange={setDialogOpen} />
    </>
  )
}
